import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  pageLoginType: null,
  currentUrl: null,
  dynamicLoginType: null,
};

const startPageSlice = createSlice({
  name: 'startPage',
  initialState,

  reducers: {
    reset: () => initialState,
    setDynamicLoginType: (state, action) => {
      state.dynamicLoginType ={
        PageUrl: window.location.pathname,
        LoginType: action.payload,
      };
    },
  },
});

export const { reset , setDynamicLoginType } = startPageSlice.actions;
export default startPageSlice.reducer;
